import React from 'react';
import style from './CoreValues.module.css';
import CoreValueCard from '../../components/CoreValueCard';
import {reputationIcon, determinationIcon, responsibilityIcon} from '../../assets';

function CoreValues(){

    const valueCardData = [
        {
            icon: reputationIcon,
            heading: "Trust-Driven Excellence",
            content: "Our reputation is built on data-backed precision and measurable results. We leverage advanced analytics to match candidates with unparalleled accuracy, delivering industry-specific insights that transform recruitment from a process to a strategic advantage."
        },
        {
            icon: determinationIcon,
            heading: "Innovative Talent Acceleration",
            content: "We proactively navigate the evolving job market with agile talent sourcing strategies. Our dedication goes beyond placements—we foster meaningful connections that fuel career growth for candidates and deliver impactful workforce solutions to clients."
        },
        {
            icon: responsibilityIcon,
            heading: "Ethical Talent Ecosystem",
            content: "We champion transparency and inclusivity in hiring by identifying diverse talent, ensuring fair selection, and fostering growth. Every step of our process helps build a more balanced, equitable, and opportunity-rich professional environment for all."
        }
    ]

    return(
    
        <div className={style.CoreValues_container}>
            <h1 data-aos="fade-up" data-aos-duration="1200" data-aos-offset="20">Our Core Values</h1>
            <div className={style.ValueCard_container}>
                <CoreValueCard data={valueCardData[0]} />
                <CoreValueCard data={valueCardData[1]} />
                <CoreValueCard data={valueCardData[2]} />
            </div>
        </div>
    );
}

export default CoreValues;